export default "__VITE_ASSET__bMSCfVXx__"